import React from 'react';
const Header = () => {
  return <header className="w-full bg-white shadow-sm py-4" data-id="element-57">
      <div className="container mx-auto px-4" data-id="element-58">
        <div className="text-2xl font-bold text-blue-600" data-id="element-59">Hjärnkraft</div>
      </div>
    </header>;
};
export default Header;